/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useSetting } from '@airasia-rn/account/hooks/settings';
import { useLogger } from '@airasia-rn/core-logger';
import { getSafeLocalStorageItem } from './safeLocalStorage';

export const TRANSLATIONS_VERSION_KEY = 'move_translations_version';

export const useTranslationsVersion = () => {
  const { value: translationsVersion } = useSetting('translations_version');
  const logger = useLogger();

  useEffect(() => {
    if (translationsVersion) {
      AsyncStorage.getItem(TRANSLATIONS_VERSION_KEY)
        .then((localVersion) => {
          AsyncStorage.setItem(
            TRANSLATIONS_VERSION_KEY,
            translationsVersion,
          ).catch(() => {});
          if (localVersion !== translationsVersion) {
            logger?.info?.(
              'translationsVersion updated might need to reloading page',
              ' from ',
              localVersion,
              ' to ',
              translationsVersion,
            );
            // Check if we should reload page, as of now not needed
            // window.location.reload();
          }
        })
        .catch((error) => {
          logger?.warn?.('Translations version storage unavailable', error);
        });
    }
  }, [logger, translationsVersion]);
};

export const getTranslationsVersion = (defaultVersion = 1) => {
  // Return early on the server
  if (typeof window === 'undefined') {
    return defaultVersion;
  }

  return Number(
    getSafeLocalStorageItem(TRANSLATIONS_VERSION_KEY) ?? defaultVersion,
  );
};
